export default __webpack_public_path__ + "64f61dca8fee7005e4a287889684b702.svg";